import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { set_page_state } from "../../../redux/actions/PageStateAction";
import { set_store } from "../../../redux/actions/CreateStoreAction";
// eslint-disable-next-line
import Auth from "j-toker";
import $ from "jquery";
import { authUrl2 } from "../../../api/Constants";
import { set_user } from "../../../redux/actions/AuthAction";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { Formik, Form, Field } from "formik";
import { TextField } from "@material-ui/core";
import * as Yup from "yup";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import { MdVisibility } from "react-icons/md";
import { MdVisibilityOff } from "react-icons/md";

import "../loginform.scss";
import ForgetModal from "../../modal/ForgetModal";
import { signin } from "../../../jtoker";

const logInSchema = Yup.object().shape({
  email: Yup.string().email().required("Required"),

  password: Yup.string()
    .required("Required")
    .min(6, "should be 6 chars minimum")
    .max(30, "should be 30 chars maximum"),
});

const LoginForm = (props) => {
  const [userType, setUserType] = useState("");
  const [showModal, setshowModal] = useState(false);
  const values = {
    email: "",
    password: "",
    role: "vendor",
  };
  const [showPassword, setShowPassword] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [auth, setAuth] = useState(true);

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const fetch = window.fetch;
  window.fetch = (...args) =>
    (async (args) => {
      var result = await fetch(...args);
      return result;
    })(args);

  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  $.auth.configure({
    apiUrl: authUrl2,
  });

  const handleSubmit = (values) => {
    setUserType("");
    setLoading(true);
    setRedirect(false);
    signin({ ...values, role: "vendor" })
      .then((response) => {
        props.set_page_state({ pageState: { id: 1 } });
        props.set_store({ store: {} });
        setLoading(false);
        if (response.data.roles.includes("vendor")) {
          localStorage.setItem(
            "access_token",
            $.auth.retrieveData("authHeaders")["access-token"],
          );
          localStorage.setItem(
            "client",
            $.auth.retrieveData("authHeaders").client,
          );
          localStorage.setItem("uid", $.auth.retrieveData("authHeaders").uid);
          setUserType("vendor");
          props.set_user({ isSignedIn: true, user: $.auth.user });
          message = "Signed in successfully";
          showSuccess();
          setRedirect(true);
        } else if (response.data.roles.includes("customer")) {
          localStorage.setItem(
            "access_token",
            $.auth.retrieveData("authHeaders")["access-token"],
          );
          localStorage.setItem(
            "client",
            $.auth.retrieveData("authHeaders").client,
          );
          localStorage.setItem("uid", $.auth.retrieveData("authHeaders").uid);
          setUserType("customer");
          props.set_user({ isSignedIn: true, user: $.auth.user });
          message = "Signed in successfully";
          showSuccess();
          props.set_page_state({ pageState: { id: 2 } });
          props.set_store({ store: {} });
          setRedirect(true);
        } else if (response.data.roles.includes("admin")) {
          message = "Admin can't login as Vendor";
          showError();
        }
      })
      .fail((error) => {
        setLoading(false);
        setRedirect(false);
        if (error.data?.errors?.base) {
          message = error.data?.errors?.full_messages[0];
          showError();
        } else if (!error.data.errors) {
          message = "Network Error!";
          showError();
        } else {
          message = error.data.errors[0];
          showError();
        }
      });
  };

  useEffect(() => {
    const authenticated = localStorage.getItem("access_token");
    if (authenticated) {
      setAuth(false);
    } else {
      localStorage.clear();
      setAuth(true);
    }
    return () => {
      setAuth(true);
    };
  }, []);
  if (auth === false && userType === "vendor") {
    return <Redirect push to="/vendor" />;
  } else if (auth === false && userType === "customer") {
    return (
      <Redirect
        push
        to={{ pathname: "/create-store", state: { type: "customer" } }}
      />
    );
  }
  return (
    <Fragment>
      <div className="login-form-desktop">
        <Formik
          initialValues={values}
          validationSchema={logInSchema}
          onSubmit={handleSubmit}
        >
          <Form className="form mx-auto">
            <Field
              style={{ width: "100%", marginBottom: "33px" }}
              as={TextField}
              name="email"
              type="email"
              label="Email"
            />
            <Field
              style={{ width: "100%", marginBottom: "10px" }}
              as={TextField}
              name="password"
              type={showPassword ? "text" : "password"}
              label="Password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <div className="link-text d-flex justify-content-end">
              <div
                className="forget-text"
                onClick={() => setshowModal(!showModal)}
                disabled={loading}
              >
                Forgot password?
              </div>
            </div>
            <button type="submit" className="signin-button" disabled={loading}>
              {loading ? (
                <ClipLoader color="#fff" loading size={20} />
              ) : (
                "SIGN IN"
              )}
            </button>
          </Form>
        </Formik>
        {showModal && (
          <div className="modal-container">
            <ForgetModal
              onClose={() => setshowModal(false)}
              title="Forget Your Password?"
            />
          </div>
        )}
      </div>
      {redirect && userType === "vendor" ? (
        <Redirect push to="/vendor/" />
      ) : userType === "customer" ? (
        <Redirect
          push
          to={{ pathname: "/create-store", state: { type: "customer" } }}
        />
      ) : (
        ""
      )}
    </Fragment>
  );
};
const mapDispatchToProps = {
  set_user,
  set_page_state,
  set_store,
};
export default connect(null, mapDispatchToProps)(LoginForm);
